import type { ExternalTableSchema } from '@packages/table-builder';
import {
  transferFmvColumn,
  transferTransactionValuesColumn,
  transferVestingUnitColumn,
} from '../transfer-and-allocate/shared/transferItemTableShared';

export const transferAllocateSelectedItemsTable: ExternalTableSchema = {
  metadata: {
    title: 'Select items for Transfer and Allocate',
    entity: 'TransferAllocateSelectedItems',
  },
  dataSource: {
    endpoint: '/api/award/api/app/transfer-allocate/for-allocate-requests',
    method: 'GET',
    rowIdField: 'id',
    fetchPolicy: 'requireFilter',
    requestParams: {
      SearchKeyWord: 'table.searchText',
      Filter: '',
      MaxResultCount: 'table.pageSize',
      SkipCount: 'table.pageOffset',
      Sorting: 'table.sorting',
      GrantId: 'filters.grantName',
      AwardTypeId: 'filters.awardTypeId',
      FromDate: 'filters.createdFromDate',
      ToDate: 'filters.createdToDate',
      SettlementTypeIds: 'filters.settlementTypeIds',
      RecordTypeId: 'filters.recordTypeId',
      IsDrs2BrokerTransferAllocate: 'filters.isSeen',
    },
    filters: [
      {
        name: 'createdFromDate',
        placeholder: 'Transaction Date From',
        type: 'date',
      },
      {
        name: 'createdToDate',
        placeholder: 'Transaction Date To',
        type: 'date',
      },
      {
        name: 'grantName',
        placeholder: 'Grant Name',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/award/api/app/grant/grants',
          labelField: 'name',
          valueField: 'id',
        },
      },
      {
        name: 'awardTypeId',
        placeholder: 'Award',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/award/api/app/plan-type/plan-type',
          labelField: 'displayName',
          valueField: 'id',
        },
      },
      {
        name: 'settlementTypeIds',
        placeholder: 'Settlement Type',
        type: 'asyncSelect',
        multiple: true,
        dataSource: {
          url: '/api/award/api/app/option-exercise/settlement-types',
          labelField: 'displayName',
          valueField: 'id',
        },
      },
      {
        name: 'recordTypeId',
        placeholder: 'Record Type',
        type: 'asyncSelect',
        dataSource: {
          url: '/api/award/api/app/status-dropdown-app-services/record-types-for-transfer-allocate',
          labelField: 'displayName',
          valueField: 'id',
        },
      },
      {
        name: 'isSeen',
        placeholder: 'Is DRS Broker Transfer Alloted',
        type: 'select',
        options: [
          { label: 'Yes', value: true },
          { label: 'No', value: false },
        ],
      },
    ],
  },
  columns: [
    {
      field: 'participantDetail',
      header: 'Participant Details',
      sortable: true,
      width: 200,
    },
    {
      field: 'transactionDate',
      header: 'Transaction Date',
      type: 'date',
      sortable: true,
      width: 200,
    },
    {
      field: 'recordType',
      header: 'Record Type',
      sortable: true,
      width: 200,
    },
    transferTransactionValuesColumn,
    transferFmvColumn,
    transferVestingUnitColumn,
    {
      field: 'grantName',
      header: 'Grant Name',
      sortable: true,
      width: 200,
    },
    {
      field: 'awardNumber',
      header: 'Award ID',
      sortable: true,
      width: 200,
    },
    {
      field: 'awardType',
      header: 'Award Type',
      type: 'badge',
      sortable: true,
      width: 200,
      align: 'center',
      badge: {
        statusMap: { RSU: 'success', PSU: 'pink-tag' },
        defaultVariant: 'default',
      },
    },
    {
      field: 'isTaxCertificationVerified',
      header: 'Tax Certification',
      type: 'badge',
      sortable: true,
      width: 200,
      align: 'center',
      badge: {
        statusMap: { true: 'success', false: 'error' },
      },
      conditionalValues: {
        true: 'CERTIFIED',
        false: 'UNCERTIFIED',
      },
    },
    {
      field: 'settlementType',
      header: 'Settlement Type',
      sortable: true,
      width: 200,
    },
    {
      field: 'fundingStatus',
      header: 'Funding Status',
      sortable: true,
      width: 200,
    },
    {
      field: 'transctionContext',
      header: 'Transaction Context',
      sortable: true,
      width: 300,
    },
  ],
  actions: {
    bulk: [{ id: 'ADD_TO_TRANSFER_ALLOCATE_SELECTED', label: 'Add to Transfer and Allocate' }],
  },
  features: {
    search: { enabled: true },
    pagination: { mode: 'infiniteScroll', defaultSize: 50 },
    selection: { keyField: 'id' },
  },
};
